import sectionGuaranteedSafeCheckoutCss from '../css-snippets/section-guaranteed-safe-checkout';

const html = `
<style>${sectionGuaranteedSafeCheckoutCss}</style>
 <div data-attribute="content">
    <figure class="image">
      <img src="/uploads/6108e532db1c052bf287acea/2026/09/10/image-6aa21325748f3bae81b33ac4.png?w=700" alt="Safe Checkout">
    </figure>
 </div>
`;
export default html;
